module.exports = __webpack_public_path__ + "img/Google Icon.6369a4e1.svg";